export const setCurrentActiveTab = (currentActive: string) => {
  return {
    type: SET_CURRENT_ACTIVE,
    payload: currentActive,
  };
};

export const SET_CURRENT_ACTIVE = "SET_CURRENT_ACTIVE"